import { css } from "styled-components";
import { ThemeProp } from "styles/theme";
import { lighten } from "utils/colors";

export const antdInputStyles = css`
  .ant-picker {
    background: ${({ theme }: ThemeProp) => lighten(theme.emptyBackground, 0)};
    border-color: ${({ theme }: ThemeProp) => lighten(theme.secondaryColor, 0)};
  }
  .ant-picker-input {
    color: ${({ theme }: ThemeProp) => theme.textInLight};
  }
  .oculus-input {
    .ant-select-selection-placeholder,
    .ant-input::placeholder {
      color: rgba(0, 0, 0, 0.75);
    }

    > div {
      color: rgba(0, 0, 0, 0.8);
    }
  }

  .ant-switch-inner {
    background: ${({ theme }: ThemeProp) => lighten(theme.textInLight, 50)};
  }
`;
